import React, { useEffect, useState } from "react";
import "./App.css";
import { RouterProvider, redirect, useLocation } from "react-router-dom";
import { router } from "./routes/routeDefinitions";
import { Store } from "./context/store";
import { TopNotification } from "./components/TopNotification";
import { Company } from "./modules/home/models/Company";
import { config } from "./config";

function App() {
  const [showNotifications, setShowNotifications] = useState(false);
  const [notificationStatus, setNotificationStatus] = useState(false);
  const [notificationCopy, setNotificationCopy] = useState("");
  const [notificationHeader, setNotificationHeader] = useState("");
  const clientCode = window.location.pathname.split("/")[1];
  const [company, setCompany] = useState<Company>();

  useEffect(() => {
    if (window.location.pathname === "/") {
      document.location.href = "https://www.hr-flex.com/";
    }
  }, []);
  return (
    <>
      <Store.Provider
        value={{
          baseUrl: config.baseUrl,
          apiKey: config.apiKey,
          showNotification: showNotifications,
          setShowNotification: setShowNotifications,
          notificationCopy: notificationCopy,
          setNotificationCopy: setNotificationCopy,
          notificationHeader: notificationHeader,
          setNotificationHeader: setNotificationHeader,
          notificationStatus: notificationStatus,
          setNotificationStatus: setNotificationStatus,
          code: clientCode,
          setCompany: setCompany,
          company: company,
        }}
      >
        <RouterProvider router={router} />
        <div className="fixed z-50">
          <TopNotification />
        </div>
      </Store.Provider>
    </>
  );
}

export default App;
